<template>
    <div>
        <v-dialog v-model="visible" transition="dialog-top-transition" scrollable persistent max-width="700">
            <v-card class="modal-maincard">

                <v-toolbar dark flat dense>
                    <v-toolbar-title>{{ title }}</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="wrapperFormModal">
                    <v-card 
                    flat
                    >
                        <v-card-text>
                            <div class="form-box-title">{{ itemsTitle }}</div>
                            <template v-if="flatItems.length === 0">
                                {{ $t('Нет_доступных_элементов') }}
                            </template>
                            <template
                                v-else
                            >
                                <v-list class="modal-select-list" dense outlined>
                                    <v-list-item-group
                                        v-model="selectedItem"
                                        color="cyan darken-1"
                                    >                                        
                                        <v-list-item
                                            v-for="(item, i) in flatItems"
                                            :key="i"
                                            :value="item"
                                            @dblclick="doubleSelect(item)"
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </template>
                        </v-card-text>
                    </v-card>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn 
                    color="cyan" 
                    text 
                    depressed 
                    @click="save" 
                    v-if="selectedItem">
                        {{ $t("Создать") }}
                    </v-btn>

                    <v-btn 
                    color="blue-grey" 
                    text
                    depressed
                    @click="cancel">
                        {{ $t("Отмена") }}
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "CreateProtocolDlg",
    data () {
        return {
            visible: false,
            resolve: null,
            reject: null,
            options: { color: 'grey lighten-3', width: 400, zIndex: 200, noconfirm: false },
            selectedItem: null,
            knownDocs: {
                Protocol: { title: "Протокол", params: { createType: "Documents.ProtocolDocument" }, requiredConfig: [8] },
                PersonalReception: { title: "Протокол_личного_приема", params: { createType: "Documents.PersonalReception" }, requiredConfig: [8] },
            },
        }
    },
    computed: {
        ...mapGetters('global/auth', ['getUserInfo']),
        title() {
            return this.$t("Создание_протокола");
        },
        itemsTitle() {
            return this.$t("Выберите_тип_протокола");
        },
        canCreateDocs() {
            let result = this.getUserInfo?.Permissions?.filter(x => x.startsWith("Create"))?.map(x => x.replace("Create", ""))?.filter(x => x.toLowerCase() != "resolution") ?? [];

            if (result.includes('Protocol'))
                result.push('PersonalReception');

            return result;
        },
        flatItems() {
            let items = [];
            
            this.canCreateDocs.forEach((item) => {
                if (this.knownDocs[item] && this.$validatePermission(this.knownDocs[item])) {

                    if (Array.isArray(this.knownDocs[item]))
                        this.knownDocs[item].forEach(item => items.push(item));
                    else
                        items.push(this.knownDocs[item]);
                }
            });
            return this.$_(items).orderBy(['title'], ['asc']).value();
        }
    },
    methods: {
        async open(options = {}) {
            this.selectedItem = null;
            this.visible = true;
            this.options = Object.assign(this.options, options);

            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        cancel() {
            this.visible = false;
            this.resolve({ isCancelled: true, message: "Действие_отменено" });
        },
        save() {
            this.visible = false;
            this.resolve(this.selectedItem);
        },
        doubleSelect(item) {
            this.visible = false;
            this.resolve(item);
        }
    }
}
</script>